import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary';

import { PrintoutPageContent } from './PrintoutPageContent';

// GPS data configuration page
export const PrintoutPage = withDefaultErrorBoundary(PrintoutPageContent)
